module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'off-canvas-menu-active': _vm.globals.off_canvas_menu_active
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "context-bg",
    style: (_vm.contextbg_css)
  }, [_c('div', {
    staticClass: "img",
    style: (_vm.contextbgimg_css)
  }, [_c('img', {
    attrs: {
      "src": _vm.$store.state.context_bg.bgimg
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade"
  })])]), _vm._v(" "), (_vm.globals.authentication_checked && _vm.globals.user.authenticated == false) ? _c('login') : _vm._e(), _vm._v(" "), (_vm.globals.authentication_checked && _vm.globals.user.authenticated == true) ? [(_vm.firebase_synced_and_ready) ? _c('div', {
    attrs: {
      "id": "menubtn"
    },
    on: {
      "click": function($event) {
        return _vm.toggleOffCanvasMenuActive()
      }
    }
  }, [_c('div'), _c('div'), _c('div')]) : _vm._e(), _vm._v(" "), (_vm.firebase_synced_and_ready) ? _c('leftnavbar') : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.globals.modal_timeline_project_popup.active) ? _c('modal-timeline-project-popup') : _vm._e(), _vm._v(" "), (_vm.firebase_synced_and_ready) ? [_c('router-view')] : _vm._e()], 2)] : _vm._e(), _vm._v(" "), _c('timelogger'), _vm._v(" "), (_vm.globals.modal_timelog_edit.active) ? _c('modal-timelog-edit') : _vm._e(), _vm._v(" "), (_vm.globals.modal_economypost_edit.active) ? _c('modal-economypost-edit') : _vm._e(), _vm._v(" "), (_vm.$store.state.timeloggerBasic.active) ? _c('modal', {
    attrs: {
      "no-dimmer-close": "",
      "cls": 'modal-timelogger-basic closebtn-outside'
    },
    on: {
      "close": function($event) {
        return _vm.$store.commit('set__timeloggerBasic_active', false)
      }
    }
  }, [_c('timelogger-basic')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.specLineRobot.active) ? _c('modal', {
    attrs: {
      "no-dimmer-close": "",
      "cls": 'spec-line-robot closebtn-outside'
    },
    on: {
      "close": function($event) {
        return _vm.$store.commit('set__specLineRobot_active', false)
      }
    }
  }, [_c('spec-line-robot')], 1) : _vm._e(), _vm._v(" "), (_vm.globals.small_spinner || _vm.$store.state.small_spinner) ? _c('div', {
    attrs: {
      "id": "small-spinner"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.firebase_synced_and_ready && _vm.user) ? [_c('div', {
    attrs: {
      "id": "small-spinner"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "app_loadbar"
    }
  }, [_c('div', {
    attrs: {
      "id": "bg"
    }
  }), _vm._v(" "), _c('div', {
    style: ({
      'width': _vm.firebase_load_pct + '%'
    }),
    attrs: {
      "id": "fill"
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "loadingtextman"
    }
  }, [_vm._v(_vm._s(_vm.loadingtextman_text))])] : _vm._e(), _vm._v(" "), (_vm.globals.big_spinner || _vm.$store.state.big_spinner) ? _c('div', {
    attrs: {
      "id": "big-spinner"
    }
  }, [_c('div', {
    attrs: {
      "id": "spinner"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "done-signal",
      "_v-if": "doneSignal"
    }
  }), _vm._v(" "), (_vm.iconSignal) ? _c('div', {
    attrs: {
      "id": "icon-signal"
    }
  }, [(_vm.iconSignal == 'heart') ? _c('svgicon', {
    attrs: {
      "icon": "ionicons/android-favorite-outline"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.iconSignal == 'check') ? _c('svgicon', {
    attrs: {
      "icon": "ionicons/checkmark"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.iconSignal == 'thumbsup') ? _c('svgicon', {
    attrs: {
      "icon": "linearicons/thumbs-up"
    }
  }) : _vm._e()], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59c95520","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 604
// module chunks = 1